var _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9, _path10, _path11, _path12, _path13, _path14, _path15, _path16, _path17, _path18, _path19, _path20, _path21, _path22, _path23, _path24, _path25, _path26, _path27, _path28, _path29, _path30, _path31, _path32, _path33, _path34, _path35, _path36, _path37, _path38, _path39, _path40, _path41, _path42, _path43, _path44, _path45, _path46, _path47, _path48, _path49, _path50, _path51, _path52, _path53, _path54, _path55, _path56, _path57, _path58, _path59, _path60, _path61, _path62, _path63, _path64, _path65, _path66, _path67, _path68, _path69, _path70, _path71, _path72, _path73, _path74, _path75, _path76, _path77, _path78, _path79, _path80, _path81, _path82, _path83, _path84, _path85, _path86, _path87, _path88, _path89, _path90, _path91, _path92, _path93, _path94, _path95, _path96, _path97, _path98, _path99, _path100, _path101, _path102, _path103, _path104, _path105, _path106, _g, _path107, _path108, _path109, _path110, _path111, _path112, _path113, _path114, _path115, _g2, _path116, _path117, _path118, _path119, _path120, _path121, _path122, _path123, _path124, _path125, _path126, _path127, _path128, _path129, _path130, _path131, _path132, _path133, _path134, _path135, _path136, _path137, _path138, _path139, _path140, _path141, _path142, _path143, _path144, _path145, _path146, _g3, _path147, _path148, _path149, _path150, _path151, _path152, _path153, _path154, _path155, _path156, _path157, _path158, _path159, _path160, _path161, _path162, _path163, _path164, _path165, _path166, _path167, _path168, _path169, _path170, _path171, _path172, _path173, _path174, _path175, _path176, _path177, _path178, _path179, _path180, _path181, _path182, _path183, _path184, _path185, _path186, _path187, _path188, _path189, _path190, _path191, _path192, _path193, _path194, _path195, _path196, _path197, _path198, _path199, _path200, _path201, _path202, _path203, _g4, _path204, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgStrategicPartnershipSection1(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 750,
    height: 569,
    viewBox: "0 0 750 569",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M110.384 511.617C256.327 587.924 492.953 587.924 638.896 511.617C784.839 435.309 784.839 311.761 638.896 235.524C492.953 159.287 256.327 159.217 110.384 235.524C-35.5588 311.832 -35.5588 435.362 110.384 511.617Z",
    fill: "#303940"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M191.004 160.902L226.177 140.601L191.004 120.3L155.512 140.601L191.004 160.902Z",
    stroke: "#658696",
    strokeWidth: 0.17475,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M163.693 140.619L191.022 61.6311V156.395L163.693 140.619Z",
    fill: "#41525B"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M191.022 156.395L218.333 140.619L191.022 61.6311V156.395Z",
    fill: "#263238"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M148.024 185.676L183.196 165.374L148.024 145.073L112.532 165.374L148.024 185.676Z",
    stroke: "#658696",
    strokeWidth: 0.17475,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M120.713 165.392L148.024 48.0911V181.168L120.713 165.392Z",
    fill: "#41525B"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M148.024 181.168L175.335 165.392L148.024 48.0911V181.168Z",
    fill: "#263238"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M105.043 210.449L140.216 190.148L105.043 169.846L69.5332 190.148L105.043 210.449Z",
    stroke: "#658696",
    strokeWidth: 0.17475,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    d: "M77.7317 190.166L105.043 120.3V205.942L77.7317 190.166Z",
    fill: "#41525B"
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    d: "M105.043 205.942L132.354 190.166L105.043 120.3V205.942Z",
    fill: "#263238"
  })), _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    d: "M62.0622 235.222L97.2348 214.921L62.0622 194.62L26.5525 214.921L62.0622 235.222Z",
    stroke: "#658696",
    strokeWidth: 0.17475,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path12 || (_path12 = /*#__PURE__*/React.createElement("path", {
    d: "M34.7332 214.939L62.062 96.3246V230.715L34.7332 214.939Z",
    fill: "#41525B"
  })), _path13 || (_path13 = /*#__PURE__*/React.createElement("path", {
    d: "M62.0623 230.715L89.3733 214.939L62.0623 96.3246V230.715Z",
    fill: "#263238"
  })), _path14 || (_path14 = /*#__PURE__*/React.createElement("path", {
    d: "M530.823 133.911L718.398 242.197",
    stroke: "#658696",
    strokeWidth: 0.17475,
    strokeMiterlimit: 10,
    strokeLinecap: "round"
  })), _path15 || (_path15 = /*#__PURE__*/React.createElement("path", {
    d: "M718.398 230.715C718.171 217.122 717.217 203.55 715.541 190.059C713.766 175.401 710.217 150.663 696.109 142.5C682.001 134.337 676.677 149.101 674.636 156.359C671.974 165.782 658.15 159.82 656.233 144.292C654.317 128.764 653.057 79.2885 636.482 69.7589C619.907 60.2293 614.566 83.2104 612.685 89.6344C608.976 102.252 598.098 98.7736 594.548 90.4153C590.999 82.0569 581.31 80.0161 577.654 91.7817C573.998 103.547 571.745 117.052 559.908 110.113C549.509 104.026 554.283 92.9352 544.15 87.6646C536.129 83.5121 532.402 103.317 532.402 123.352L718.398 230.715Z",
    fill: "#41525B"
  })), _path16 || (_path16 = /*#__PURE__*/React.createElement("path", {
    d: "M704.769 127.451C704.769 129.616 702.817 130.237 700.439 128.871L686.242 120.637C685.075 119.975 684.077 119.053 683.326 117.941C682.575 116.83 682.091 115.56 681.912 114.23C681.912 112.083 683.864 111.444 686.242 112.828L700.439 121.062C701.605 121.72 702.604 122.639 703.355 123.748C704.106 124.856 704.59 126.124 704.769 127.451Z",
    fill: "#263238"
  })), _path17 || (_path17 = /*#__PURE__*/React.createElement("path", {
    d: "M646.491 57.8335C646.491 59.9985 644.557 60.6196 642.161 59.2531L627.964 51.019C626.795 50.3608 625.794 49.4391 625.043 48.3271C624.291 47.2152 623.809 45.9434 623.634 44.6127C623.634 42.4655 625.569 41.8266 627.964 43.2108L642.161 51.4449C643.329 52.1004 644.329 53.0189 645.081 54.1278C645.832 55.2368 646.315 56.5055 646.491 57.8335Z",
    fill: "#263238"
  })), _path18 || (_path18 = /*#__PURE__*/React.createElement("path", {
    d: "M600.334 70.6461C600.334 72.8111 598.399 73.4322 596.021 72.0658L581.825 63.8316C580.655 63.1734 579.655 62.2517 578.903 61.1398C578.152 60.0278 577.669 58.756 577.495 57.4253C577.495 55.2781 579.429 54.6392 581.825 56.0234L596.021 64.2575C597.186 64.9161 598.181 65.8359 598.929 66.9445C599.678 68.053 600.158 69.3202 600.334 70.6461Z",
    fill: "#263238"
  })), _path19 || (_path19 = /*#__PURE__*/React.createElement("path", {
    d: "M556.572 74.8875C556.572 77.0525 554.638 77.6736 552.242 76.2894L538.045 68.073C536.881 67.4105 535.885 66.4874 535.137 65.3759C534.389 64.2645 533.908 62.9949 533.733 61.6667C533.733 59.5194 535.667 58.8806 538.045 60.2647L552.242 68.4811C553.41 69.1416 554.409 70.0638 555.16 71.1753C555.911 72.2869 556.395 73.5576 556.572 74.8875Z",
    fill: "#263238"
  })), _path20 || (_path20 = /*#__PURE__*/React.createElement("path", {
    d: "M523.014 117.922V0.602783",
    stroke: "#658696",
    strokeWidth: 0.17475,
    strokeMiterlimit: 10,
    strokeLinecap: "round"
  })), _path21 || (_path21 = /*#__PURE__*/React.createElement("path", {
    d: "M68.3438 377.421C68.3438 377.421 71.2542 351.37 63.1797 326.561C55.5844 303.101 40.3229 290.661 31.0772 286.935C13.5974 279.96 12.0358 299.215 25.1323 312.542C34.7329 322.338 57.8382 342.533 61.8133 376.782L68.3438 377.421Z",
    fill: "url(#paint0_linear_2263_7536)"
  })), _path22 || (_path22 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.7,
    d: "M68.3438 377.421C68.3438 377.421 71.2542 351.37 63.1797 326.561C55.5844 303.101 40.3229 290.661 31.0772 286.935C13.5974 279.96 12.0358 299.215 25.1323 312.542C34.7329 322.338 57.8382 342.533 61.8133 376.782L68.3438 377.421Z",
    fill: "#1C262B"
  })), _path23 || (_path23 = /*#__PURE__*/React.createElement("path", {
    d: "M26.3569 292.312C36.9158 299.41 65.2917 319.907 66.3209 377.226",
    stroke: "#658696",
    strokeWidth: 0.17475,
    strokeMiterlimit: 10,
    strokeLinecap: "round"
  })), _path24 || (_path24 = /*#__PURE__*/React.createElement("path", {
    d: "M60.9086 395.221C55.4783 368.957 44.387 359.427 24.5648 349.276C16.0822 344.946 6.14442 340.119 2.55973 334.6C-1.02496 329.081 0.785133 321.664 12.9944 321.823C35.3011 322.125 60.7134 349.01 64.1028 378.468L60.9086 395.221Z",
    fill: "url(#paint1_linear_2263_7536)"
  })), _path25 || (_path25 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.8,
    d: "M60.9086 395.221C55.4783 368.957 44.387 359.427 24.5648 349.276C16.0822 344.946 6.14442 340.119 2.55973 334.6C-1.02496 329.081 0.785133 321.664 12.9944 321.823C35.3011 322.125 60.7134 349.01 64.1028 378.468L60.9086 395.221Z",
    fill: "#1C262B"
  })), _path26 || (_path26 = /*#__PURE__*/React.createElement("path", {
    d: "M11.1133 327.537C27.9542 329.827 54.5555 349.454 63.0026 384.325",
    stroke: "#658696",
    strokeWidth: 0.17475,
    strokeMiterlimit: 10,
    strokeLinecap: "round"
  })), _path27 || (_path27 = /*#__PURE__*/React.createElement("path", {
    d: "M683.065 365.123C689.897 351.991 695.204 315.151 686.419 298.115C677.635 281.078 664.574 282.445 662.551 287.964C660.776 293.057 665.16 302.161 670.838 313.003C676.517 323.846 681.308 347.076 675.931 357.901L683.065 365.123Z",
    fill: "url(#paint2_linear_2263_7536)"
  })), _path28 || (_path28 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.7,
    d: "M683.065 365.123C689.897 351.991 695.204 315.151 686.419 298.115C677.635 281.078 664.574 282.445 662.551 287.964C660.776 293.057 665.16 302.161 670.838 313.003C676.517 323.846 681.308 347.076 675.931 357.901L683.065 365.123Z",
    fill: "#1C262B"
  })), _path29 || (_path29 = /*#__PURE__*/React.createElement("path", {
    d: "M671.176 288.851C676.766 293.341 692.772 320.794 681.575 358.469",
    stroke: "#658696",
    strokeWidth: 0.17475,
    strokeMiterlimit: 10,
    strokeLinecap: "round"
  })), _path30 || (_path30 = /*#__PURE__*/React.createElement("path", {
    d: "M680.9 379.036C676.783 370.802 667.768 357.173 673.908 347.821C680.049 338.469 686.473 346.739 691.406 340.634C696.339 334.529 690.696 324.662 694.955 319.339C703.189 308.869 709.152 321.025 715.612 319.427C720.279 318.274 725.478 307.928 738.912 309.188C752.346 310.448 751.671 321.096 745.691 326.1C739.711 331.104 732.612 336.091 737.226 343.597C741.308 350.252 743.42 362.55 729.453 367.324C716.108 371.885 722.71 377.67 720.58 384.2C718.451 390.731 705.851 396.924 692.453 391.884L680.9 379.036Z",
    fill: "url(#paint3_linear_2263_7536)"
  })), _path31 || (_path31 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.8,
    d: "M680.9 379.036C676.783 370.802 667.768 357.173 673.908 347.821C680.049 338.469 686.473 346.739 691.406 340.634C696.339 334.529 690.696 324.662 694.955 319.339C703.189 308.869 709.152 321.025 715.612 319.427C720.279 318.274 725.478 307.928 738.912 309.188C752.346 310.448 751.671 321.096 745.691 326.1C739.711 331.104 732.612 336.091 737.226 343.597C741.308 350.252 743.42 362.55 729.453 367.324C716.108 371.885 722.71 377.67 720.58 384.2C718.451 390.731 705.851 396.924 692.453 391.884L680.9 379.036Z",
    fill: "#1C262B"
  })), _path32 || (_path32 = /*#__PURE__*/React.createElement("path", {
    d: "M740.758 315.222C726.206 319.126 691.353 347.448 688.407 382.994",
    stroke: "#658696",
    strokeWidth: 0.17475,
    strokeMiterlimit: 10,
    strokeLinecap: "round"
  })), _path33 || (_path33 = /*#__PURE__*/React.createElement("path", {
    d: "M730.27 352.542C723.082 350.909 704.822 350.678 697.99 353.997",
    stroke: "#658696",
    strokeWidth: 0.17475,
    strokeMiterlimit: 10,
    strokeLinecap: "round"
  })), _path34 || (_path34 = /*#__PURE__*/React.createElement("path", {
    d: "M702.053 322.462C702.053 322.462 707.377 332.772 706.614 341.45",
    stroke: "#658696",
    strokeWidth: 0.17475,
    strokeMiterlimit: 10,
    strokeLinecap: "round"
  })), _path35 || (_path35 = /*#__PURE__*/React.createElement("path", {
    d: "M503.547 221.753C501.168 213.518 496.917 205.944 491.125 199.624C484.28 192.159 476.274 185.849 467.416 180.937C457.131 175.112 446.195 170.519 434.835 167.255C422.32 163.643 409.481 161.266 396.503 160.157C383.097 158.932 369.608 158.932 356.202 160.157C343.23 161.266 330.397 163.643 317.888 167.255C306.521 170.516 295.579 175.108 285.289 180.937C276.431 185.892 268.431 192.244 261.598 199.748C255.811 206.072 251.561 213.644 249.176 221.878C247.056 229.494 247.056 237.544 249.176 245.16C251.542 253.396 255.795 260.967 261.598 267.272C268.436 274.783 276.442 281.141 285.307 286.1C295.584 291.925 306.515 296.511 317.871 299.765C330.385 303.393 343.223 305.794 356.202 306.934C369.609 308.141 383.097 308.141 396.503 306.934C409.489 305.789 422.333 303.382 434.852 299.747C446.208 296.494 457.139 291.907 467.416 286.083C476.284 281.128 484.291 274.769 491.125 267.254C496.92 260.944 501.172 253.375 503.547 245.142C505.67 237.491 505.67 229.405 503.547 221.753Z",
    fill: "#37474F"
  })), _path36 || (_path36 = /*#__PURE__*/React.createElement("path", {
    d: "M247.579 221.789H505.126V234.921L247.579 234.193V221.789Z",
    fill: "#37474F"
  })), _path37 || (_path37 = /*#__PURE__*/React.createElement("path", {
    d: "M356.202 148.391L376.326 221.753L317.888 155.561C330.395 151.924 343.227 149.523 356.202 148.391Z",
    fill: "#455A64"
  })), _path38 || (_path38 = /*#__PURE__*/React.createElement("path", {
    d: "M396.503 148.391L376.379 221.753L356.255 148.356C369.644 147.146 383.116 147.158 396.503 148.391Z",
    fill: "#455A64"
  })), _path39 || (_path39 = /*#__PURE__*/React.createElement("path", {
    d: "M434.834 155.561L376.379 221.753L396.503 148.356C409.485 149.5 422.323 151.913 434.834 155.561Z",
    fill: "#455A64"
  })), _path40 || (_path40 = /*#__PURE__*/React.createElement("path", {
    d: "M491.107 188.036C496.896 194.365 501.146 201.944 503.529 210.183L376.397 221.753L491.107 188.036Z",
    fill: "#455A64"
  })), _path41 || (_path41 = /*#__PURE__*/React.createElement("path", {
    d: "M503.547 210.201C505.65 217.813 505.65 225.853 503.547 233.466L376.397 221.753L503.547 210.201Z",
    fill: "#455A64"
  })), _path42 || (_path42 = /*#__PURE__*/React.createElement("path", {
    d: "M503.547 233.466C501.169 241.702 496.917 249.276 491.125 255.595L376.397 221.878L503.547 233.466Z",
    fill: "#455A64"
  })), _path43 || (_path43 = /*#__PURE__*/React.createElement("path", {
    d: "M491.125 255.595C484.289 263.104 476.283 269.456 467.416 274.406L376.361 221.753L491.125 255.595Z",
    fill: "#455A64"
  })), _path44 || (_path44 = /*#__PURE__*/React.createElement("path", {
    d: "M376.379 221.842L434.852 288.088C422.332 291.702 409.487 294.079 396.503 295.186L376.361 221.789L376.379 221.842Z",
    fill: "#455A64"
  })), _path45 || (_path45 = /*#__PURE__*/React.createElement("path", {
    d: "M376.361 221.86L396.503 295.257C383.097 296.482 369.608 296.482 356.202 295.257L376.361 221.86Z",
    fill: "#455A64"
  })), _path46 || (_path46 = /*#__PURE__*/React.createElement("path", {
    d: "M376.326 221.842L356.166 295.239C343.182 294.132 330.338 291.755 317.817 288.141L376.326 221.842Z",
    fill: "#455A64"
  })), _path47 || (_path47 = /*#__PURE__*/React.createElement("path", {
    d: "M376.326 221.842L317.764 288.088C306.41 284.821 295.48 280.228 285.2 274.406L376.326 221.842Z",
    fill: "#455A64"
  })), _path48 || (_path48 = /*#__PURE__*/React.createElement("path", {
    d: "M376.308 221.753L261.58 255.471C255.78 249.157 251.527 241.581 249.158 233.341L376.308 221.753Z",
    fill: "#455A64"
  })), _path49 || (_path49 = /*#__PURE__*/React.createElement("path", {
    d: "M376.308 221.753L249.176 233.466C247.055 225.856 247.055 217.811 249.176 210.201L376.308 221.753Z",
    fill: "#455A64"
  })), _path50 || (_path50 = /*#__PURE__*/React.createElement("path", {
    d: "M376.308 221.753L249.176 210.13C251.564 201.893 255.814 194.315 261.598 187.983L376.308 221.753Z",
    fill: "#455A64"
  })), _path51 || (_path51 = /*#__PURE__*/React.createElement("path", {
    d: "M285.289 169.261L376.308 221.753L261.598 188.036C268.433 180.544 276.433 174.204 285.289 169.261Z",
    fill: "#455A64"
  })), _path52 || (_path52 = /*#__PURE__*/React.createElement("path", {
    d: "M467.416 169.261L376.379 221.753L434.834 155.525C446.2 158.799 457.137 163.409 467.416 169.261Z",
    fill: "#455A64"
  })), _path53 || (_path53 = /*#__PURE__*/React.createElement("path", {
    d: "M467.416 169.261C476.275 174.199 484.275 180.54 491.107 188.036L376.397 221.753L467.416 169.261Z",
    fill: "#455A64"
  })), _path54 || (_path54 = /*#__PURE__*/React.createElement("path", {
    d: "M376.326 221.753L285.254 274.335C276.39 269.381 268.384 263.029 261.545 255.524L376.273 221.807L376.326 221.753Z",
    fill: "#455A64"
  })), _path55 || (_path55 = /*#__PURE__*/React.createElement("path", {
    d: "M317.888 155.561L376.326 221.753L285.289 169.19C295.577 163.372 306.52 158.797 317.888 155.561Z",
    fill: "#455A64"
  })), _path56 || (_path56 = /*#__PURE__*/React.createElement("path", {
    d: "M376.379 221.842L467.416 274.406C457.136 280.228 446.206 284.821 434.852 288.088L376.379 221.842Z",
    fill: "#455A64"
  })), _path57 || (_path57 = /*#__PURE__*/React.createElement("path", {
    d: "M298.474 147.717L370.789 189.456L367.24 130.45C340.639 131.586 318.048 137.265 298.474 147.717Z",
    fill: "url(#paint4_linear_2263_7536)"
  })), _path58 || (_path58 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.2,
    d: "M298.474 147.717L370.789 189.456L367.24 130.45C340.639 131.586 318.048 137.265 298.474 147.717Z",
    fill: "#1C262B"
  })), _path59 || (_path59 = /*#__PURE__*/React.createElement("path", {
    d: "M370.789 189.456V212.241L298.474 170.485V147.717L370.789 189.456Z",
    fill: "url(#paint5_linear_2263_7536)"
  })), _path60 || (_path60 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.1,
    d: "M370.789 189.456V212.241L298.474 170.485V147.717L370.789 189.456Z",
    fill: "black"
  })), _path61 || (_path61 = /*#__PURE__*/React.createElement("path", {
    d: "M464.541 153.573L381.543 191.017V213.785L464.541 176.341V153.573Z",
    fill: "url(#paint6_linear_2263_7536)"
  })), _path62 || (_path62 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.3,
    d: "M464.541 153.573L381.543 191.017V213.785L464.541 176.341V153.573Z",
    fill: "black"
  })), _path63 || (_path63 = /*#__PURE__*/React.createElement("path", {
    d: "M464.541 153.573C442.199 138.365 412.404 130.344 377.87 130.237L380.088 167.131L381.543 191.017L464.541 153.573Z",
    fill: "url(#paint7_linear_2263_7536)"
  })), _path64 || (_path64 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.1,
    d: "M464.541 153.573C442.199 138.365 412.404 130.344 377.87 130.237L380.088 167.131L381.543 191.017L464.541 153.573Z",
    fill: "black"
  })), _path65 || (_path65 = /*#__PURE__*/React.createElement("path", {
    d: "M377.852 130.237V153.005L381.543 213.785V191.017L377.852 130.237Z",
    fill: "#263238"
  })), _path66 || (_path66 = /*#__PURE__*/React.createElement("path", {
    d: "M398.42 234.868L440.85 275.683C443.228 274.778 445.429 273.909 447.949 272.702C477.177 259.534 492.456 239.801 492.438 219.89V197.352C489.226 188.781 480.389 188.799 471.143 181.257L384.489 220.298L383.62 220.688L398.42 234.868Z",
    fill: "url(#paint8_linear_2263_7536)"
  })), _path67 || (_path67 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.6,
    d: "M398.42 234.868L440.85 275.683C443.228 274.778 445.429 273.909 447.949 272.702C477.177 259.534 492.456 239.801 492.438 219.89V197.352C489.226 188.781 480.389 188.799 471.143 181.257L384.489 220.298L383.62 220.688L398.42 234.868Z",
    fill: "#1C262B"
  })), _path68 || (_path68 = /*#__PURE__*/React.createElement("path", {
    d: "M398.42 212.099L440.85 252.915C443.228 252.01 445.429 251.141 447.949 249.916C496.874 227.822 506.67 187.362 471.178 158.418L384.525 197.459L383.655 197.849L398.42 212.099Z",
    fill: "url(#paint9_linear_2263_7536)"
  })), _path69 || (_path69 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.8,
    d: "M398.42 212.099L440.85 252.915C443.228 252.01 445.429 251.141 447.949 249.916C496.874 227.822 506.67 187.362 471.178 158.418L384.525 197.459L383.655 197.849L398.42 212.099Z",
    fill: "#1C262B"
  })), _path70 || (_path70 = /*#__PURE__*/React.createElement("path", {
    d: "M440.779 275.648V252.862L383.566 197.903V220.671L440.779 275.648Z",
    fill: "url(#paint10_linear_2263_7536)"
  })), _path71 || (_path71 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.6,
    d: "M440.779 275.648V252.862L383.566 197.903V220.671L440.779 275.648Z",
    fill: "#1C262B"
  })), _path72 || (_path72 = /*#__PURE__*/React.createElement("path", {
    d: "M290.95 174.833C278.758 182.517 265.218 187.362 260.285 196.696V219.482C260.285 231.354 265.804 243.386 277.25 254.388C293.221 269.703 318.51 280.528 348.553 284.84C376.358 288.945 404.724 286.879 431.64 278.789V256.021L394.285 242.889L372.351 221.753L290.95 174.833Z",
    fill: "url(#paint11_linear_2263_7536)"
  })), _path73 || (_path73 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.6,
    d: "M290.95 174.833C278.758 182.517 265.218 187.362 260.285 196.696V219.482C260.285 231.354 265.804 243.386 277.25 254.388C293.221 269.703 318.51 280.528 348.553 284.84C376.358 288.945 404.724 286.879 431.64 278.789V256.021L394.285 242.889L372.351 221.753L290.95 174.833Z",
    fill: "black"
  })), _path74 || (_path74 = /*#__PURE__*/React.createElement("path", {
    d: "M290.95 152.065C255.919 174.105 250.276 205.693 277.25 231.602C293.222 246.935 318.51 257.742 348.554 262.072C376.358 266.167 404.723 264.102 431.64 256.021L394.285 220.121L372.351 199.056L290.95 152.065Z",
    fill: "url(#paint12_linear_2263_7536)"
  })), _path75 || (_path75 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.3,
    d: "M290.95 152.065C255.919 174.105 250.276 205.693 277.25 231.602C293.222 246.935 318.51 257.742 348.554 262.072C376.358 266.167 404.723 264.102 431.64 256.021L394.285 220.121L372.351 199.056L290.95 152.065Z",
    fill: "black"
  })), _path76 || (_path76 = /*#__PURE__*/React.createElement("path", {
    d: "M697.422 400.367C695.043 392.131 690.792 384.557 685 378.237C678.17 370.73 670.169 364.378 661.309 359.427C651.024 353.601 640.088 349.008 628.727 345.745C616.213 342.132 603.374 339.755 590.396 338.646C576.99 337.422 563.501 337.422 550.095 338.646C537.123 339.757 524.29 342.134 511.781 345.745C500.42 349.008 489.484 353.601 479.2 359.427C470.333 364.376 462.327 370.729 455.491 378.237C449.704 384.561 445.453 392.134 443.069 400.367C440.948 407.983 440.948 416.033 443.069 423.649C445.434 431.885 449.688 439.456 455.491 445.761C462.329 453.272 470.335 459.63 479.2 464.59C489.48 470.408 500.41 474.994 511.763 478.254C524.286 481.858 537.13 484.235 550.113 485.352C563.519 486.559 577.007 486.559 590.414 485.352C603.397 484.237 616.24 481.859 628.763 478.254C640.122 475.002 651.054 470.409 661.327 464.572C670.2 459.624 678.212 453.272 685.053 445.761C690.844 439.447 695.095 431.879 697.475 423.649C699.57 416.027 699.552 407.979 697.422 400.367Z",
    fill: "#37474F"
  })), _path77 || (_path77 = /*#__PURE__*/React.createElement("path", {
    d: "M441.454 400.349H699.001V413.481L441.454 412.754V400.349Z",
    fill: "#37474F"
  })), _path78 || (_path78 = /*#__PURE__*/React.createElement("path", {
    d: "M550.077 326.952L570.219 400.349L511.763 334.121C524.27 330.486 537.102 328.085 550.077 326.952Z",
    fill: "#455A64"
  })), _path79 || (_path79 = /*#__PURE__*/React.createElement("path", {
    d: "M590.378 326.952L570.254 400.349L550.113 326.952C563.507 325.729 576.984 325.729 590.378 326.952Z",
    fill: "#455A64"
  })), _path80 || (_path80 = /*#__PURE__*/React.createElement("path", {
    d: "M628.709 334.121L570.254 400.349L590.378 326.952C603.359 328.084 616.197 330.485 628.709 334.121Z",
    fill: "#455A64"
  })), _path81 || (_path81 = /*#__PURE__*/React.createElement("path", {
    d: "M684.982 366.614C690.774 372.94 695.026 380.52 697.404 388.761L570.272 400.385L684.982 366.614Z",
    fill: "#455A64"
  })), _path82 || (_path82 = /*#__PURE__*/React.createElement("path", {
    d: "M697.422 388.761C699.533 396.372 699.533 404.415 697.422 412.026L570.29 400.385L697.422 388.761Z",
    fill: "#455A64"
  })), _path83 || (_path83 = /*#__PURE__*/React.createElement("path", {
    d: "M697.422 412.026C695.038 420.26 690.788 427.832 685 434.155L570.272 400.438L697.422 412.026Z",
    fill: "#455A64"
  })), _path84 || (_path84 = /*#__PURE__*/React.createElement("path", {
    d: "M685.018 434.155C678.167 441.656 670.156 448.007 661.291 452.966L570.237 400.385L685.018 434.155Z",
    fill: "#455A64"
  })), _path85 || (_path85 = /*#__PURE__*/React.createElement("path", {
    d: "M570.254 400.402L628.727 466.648C616.205 470.253 603.361 472.631 590.378 473.747L570.237 400.349L570.254 400.402Z",
    fill: "#455A64"
  })), _path86 || (_path86 = /*#__PURE__*/React.createElement("path", {
    d: "M570.236 400.42L590.378 473.747C576.972 474.962 563.483 474.962 550.077 473.747L570.236 400.42Z",
    fill: "#455A64"
  })), _path87 || (_path87 = /*#__PURE__*/React.createElement("path", {
    d: "M570.219 400.402L550.077 473.747C537.094 472.629 524.25 470.252 511.728 466.648L570.219 400.402Z",
    fill: "#455A64"
  })), _path88 || (_path88 = /*#__PURE__*/React.createElement("path", {
    d: "M570.219 400.402L511.657 466.648C500.305 463.375 489.376 458.783 479.093 452.966L570.219 400.402Z",
    fill: "#455A64"
  })), _path89 || (_path89 = /*#__PURE__*/React.createElement("path", {
    d: "M570.183 400.385L455.455 434.102C449.655 427.788 445.402 420.212 443.033 411.973L570.183 400.385Z",
    fill: "#455A64"
  })), _path90 || (_path90 = /*#__PURE__*/React.createElement("path", {
    d: "M570.183 400.385L443.051 412.026C440.93 404.416 440.93 396.371 443.051 388.761L570.183 400.385Z",
    fill: "#455A64"
  })), _path91 || (_path91 = /*#__PURE__*/React.createElement("path", {
    d: "M570.183 400.367L443.051 388.743C445.435 380.504 449.686 372.926 455.473 366.596L570.183 400.367Z",
    fill: "#455A64"
  })), _path92 || (_path92 = /*#__PURE__*/React.createElement("path", {
    d: "M479.182 347.75L570.183 400.296L455.473 366.578C462.307 359.063 470.314 352.705 479.182 347.75Z",
    fill: "#455A64"
  })), _path93 || (_path93 = /*#__PURE__*/React.createElement("path", {
    d: "M661.291 347.75L570.254 400.296L628.709 334.068C640.073 337.324 651.01 341.917 661.291 347.75Z",
    fill: "#455A64"
  })), _path94 || (_path94 = /*#__PURE__*/React.createElement("path", {
    d: "M661.291 347.75C670.151 352.694 678.152 359.04 684.982 366.543L570.29 400.26L661.291 347.75Z",
    fill: "#455A64"
  })), _path95 || (_path95 = /*#__PURE__*/React.createElement("path", {
    d: "M570.219 400.367L479.164 452.966C470.304 448.007 462.299 441.656 455.455 434.155L570.183 400.438L570.219 400.367Z",
    fill: "#455A64"
  })), _path96 || (_path96 = /*#__PURE__*/React.createElement("path", {
    d: "M511.763 334.121L570.219 400.349L479.182 347.75C489.465 341.935 500.402 337.36 511.763 334.121Z",
    fill: "#455A64"
  })), _path97 || (_path97 = /*#__PURE__*/React.createElement("path", {
    d: "M570.254 400.402L661.291 452.966C651.011 458.789 640.081 463.381 628.727 466.648L570.254 400.402Z",
    fill: "#455A64"
  })), _path98 || (_path98 = /*#__PURE__*/React.createElement("path", {
    d: "M456.786 371.547V408.423C455.852 405.054 455.374 401.574 455.366 398.077V371.547H456.786Z",
    fill: "url(#paint13_linear_2263_7536)"
  })), _path99 || (_path99 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.3,
    d: "M456.786 371.547V408.423C455.852 405.054 455.374 401.574 455.366 398.077V371.547H456.786Z",
    fill: "black"
  })), _path100 || (_path100 = /*#__PURE__*/React.createElement("path", {
    d: "M570.183 371.583L456.786 381.946C454.905 375.159 454.905 367.988 456.786 361.201L570.183 371.583Z",
    fill: "url(#paint14_linear_2263_7536)"
  })), _path101 || (_path101 = /*#__PURE__*/React.createElement("path", {
    d: "M570.183 371.547L456.786 361.166C458.918 353.818 462.713 347.059 467.878 341.415L570.183 371.547Z",
    fill: "url(#paint15_linear_2263_7536)"
  })), _path102 || (_path102 = /*#__PURE__*/React.createElement("path", {
    d: "M489.013 324.68L570.183 371.547L467.878 341.379C473.98 334.714 481.117 329.075 489.013 324.68Z",
    fill: "url(#paint16_linear_2263_7536)"
  })), _path103 || (_path103 = /*#__PURE__*/React.createElement("path", {
    d: "M518.081 312.471L570.219 371.529L489.013 324.68C498.186 319.476 507.943 315.378 518.081 312.471Z",
    fill: "url(#paint17_linear_2263_7536)"
  })), _path104 || (_path104 = /*#__PURE__*/React.createElement("path", {
    d: "M552.26 306.082L570.219 371.53L518.081 312.471C529.237 309.226 540.685 307.086 552.26 306.082Z",
    fill: "url(#paint18_linear_2263_7536)"
  })), _path105 || (_path105 = /*#__PURE__*/React.createElement("path", {
    d: "M588.302 306.082L570.254 371.53L552.295 306.082C564.272 304.979 576.325 304.979 588.302 306.082Z",
    fill: "url(#paint19_linear_2263_7536)"
  })), _path106 || (_path106 = /*#__PURE__*/React.createElement("path", {
    d: "M622.392 312.471L570.254 371.53L588.302 306.082C599.847 307.092 611.265 309.231 622.392 312.471Z",
    fill: "url(#paint20_linear_2263_7536)"
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    opacity: 0.2
  }, /*#__PURE__*/React.createElement("path", {
    d: "M570.183 371.583L456.786 381.946C454.905 375.159 454.905 367.988 456.786 361.201L570.183 371.583Z",
    fill: "#1C262B"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M570.183 371.547L456.786 361.166C458.918 353.818 462.713 347.059 467.878 341.415L570.183 371.547Z",
    fill: "#1C262B"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M489.013 324.68L570.183 371.547L467.878 341.379C473.98 334.714 481.117 329.075 489.013 324.68Z",
    fill: "#1C262B"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M518.081 312.471L570.219 371.529L489.013 324.68C498.186 319.476 507.943 315.378 518.081 312.471Z",
    fill: "#1C262B"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M552.26 306.082L570.219 371.53L518.081 312.471C529.237 309.226 540.685 307.086 552.26 306.082Z",
    fill: "#1C262B"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M588.302 306.082L570.254 371.53L552.295 306.082C564.272 304.979 576.325 304.979 588.302 306.082Z",
    fill: "#1C262B"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M622.392 312.471L570.254 371.53L588.302 306.082C599.847 307.092 611.265 309.231 622.392 312.471Z",
    fill: "#1C262B"
  }))), _path107 || (_path107 = /*#__PURE__*/React.createElement("path", {
    d: "M666.384 389.258L649.366 405.229L636.429 417.456L624.095 429.062L622.445 430.606V457.101C632.581 454.196 642.338 450.104 651.513 444.909C659.418 440.476 666.561 434.802 672.666 428.104C677.829 422.477 681.614 415.728 683.722 408.388C684.662 405.019 685.146 401.539 685.159 398.042V371.565L666.384 389.258Z",
    fill: "url(#paint21_linear_2263_7536)"
  })), _path108 || (_path108 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.3,
    d: "M666.384 389.258L649.366 405.229L636.429 417.456L624.095 429.062L622.445 430.606V457.101C632.581 454.196 642.338 450.104 651.513 444.909C659.418 440.476 666.561 434.802 672.666 428.104C677.829 422.477 681.614 415.728 683.722 408.388C684.662 405.019 685.146 401.539 685.159 398.042V371.565L666.384 389.258Z",
    fill: "black"
  })), _path109 || (_path109 = /*#__PURE__*/React.createElement("path", {
    d: "M672.595 341.45C677.754 347.1 681.548 353.856 683.687 361.201L570.272 371.583L672.595 341.45Z",
    fill: "url(#paint22_linear_2263_7536)"
  })), _path110 || (_path110 = /*#__PURE__*/React.createElement("path", {
    d: "M685.106 371.6C685.092 375.104 684.609 378.589 683.669 381.964L649.313 378.805L570.272 371.565L666.331 362.692L683.669 361.113C684.619 364.528 685.102 368.056 685.106 371.6Z",
    fill: "url(#paint23_linear_2263_7536)"
  })), _path111 || (_path111 = /*#__PURE__*/React.createElement("path", {
    d: "M683.669 381.964C681.557 389.302 677.773 396.051 672.613 401.68L636.376 391.032L570.272 371.512L649.313 378.752L683.669 381.964Z",
    fill: "url(#paint24_linear_2263_7536)"
  })), _path112 || (_path112 = /*#__PURE__*/React.createElement("path", {
    d: "M672.613 401.68C666.507 408.378 659.365 414.053 651.46 418.485L624.042 402.621L570.29 371.601L636.393 391.121L672.613 401.68Z",
    fill: "url(#paint25_linear_2263_7536)"
  })), _path113 || (_path113 = /*#__PURE__*/React.createElement("path", {
    d: "M651.46 324.68L570.254 371.565L622.392 312.506C632.526 315.409 642.282 319.495 651.46 324.68Z",
    fill: "url(#paint26_linear_2263_7536)"
  })), _path114 || (_path114 = /*#__PURE__*/React.createElement("path", {
    d: "M651.46 324.68C659.358 329.101 666.494 334.764 672.595 341.45L570.272 371.618L651.46 324.68Z",
    fill: "url(#paint27_linear_2263_7536)"
  })), _path115 || (_path115 = /*#__PURE__*/React.createElement("path", {
    d: "M651.46 418.485C642.284 423.674 632.527 427.761 622.392 430.659L570.29 371.601L624.042 402.621L651.46 418.485Z",
    fill: "url(#paint28_linear_2263_7536)"
  })), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    opacity: 0.2
  }, /*#__PURE__*/React.createElement("path", {
    d: "M672.595 341.45C677.754 347.1 681.548 353.856 683.687 361.201L570.272 371.583L672.595 341.45Z",
    fill: "#1C262B"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M685.106 371.6C685.092 375.104 684.609 378.589 683.669 381.964L649.313 378.805L570.272 371.565L666.331 362.692L683.669 361.113C684.619 364.528 685.102 368.056 685.106 371.6Z",
    fill: "#1C262B"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M683.669 381.964C681.557 389.302 677.773 396.051 672.613 401.68L636.376 391.032L570.272 371.512L649.313 378.752L683.669 381.964Z",
    fill: "#1C262B"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M672.613 401.68C666.508 408.378 659.365 414.053 651.46 418.485L624.042 402.621L570.29 371.601L636.394 391.121L672.613 401.68Z",
    fill: "#1C262B"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M651.46 324.68L570.254 371.565L622.392 312.506C632.526 315.409 642.282 319.495 651.46 324.68Z",
    fill: "#1C262B"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M651.46 324.68C659.358 329.101 666.494 334.764 672.595 341.45L570.272 371.618L651.46 324.68Z",
    fill: "#1C262B"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M651.46 418.485C642.284 423.674 632.527 427.761 622.392 430.659L570.29 371.601L624.042 402.621L651.46 418.485Z",
    fill: "#1C262B"
  }))), _path116 || (_path116 = /*#__PURE__*/React.createElement("path", {
    d: "M622.41 430.677V457.172L570.219 398.042V371.53L622.41 430.677Z",
    fill: "#263238"
  })), _path117 || (_path117 = /*#__PURE__*/React.createElement("path", {
    d: "M570.219 398.042L456.786 408.459V381.946L570.219 371.53V398.042Z",
    fill: "url(#paint29_linear_2263_7536)"
  })), _path118 || (_path118 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.1,
    d: "M570.219 398.042L456.786 408.459V381.946L570.219 371.53V398.042Z",
    fill: "black"
  })), _path119 || (_path119 = /*#__PURE__*/React.createElement("path", {
    d: "M309.69 400.367C307.311 392.131 303.059 384.557 297.268 378.237C290.434 370.733 282.434 364.381 273.577 359.427C263.287 353.598 252.345 349.005 240.977 345.745C228.469 342.132 215.636 339.755 202.664 338.646C189.258 337.422 175.768 337.422 162.362 338.646C149.384 339.757 136.546 342.134 124.031 345.745C112.658 349.006 101.71 353.598 91.414 359.427C82.5538 364.378 74.5533 370.73 67.7231 378.237C61.9312 384.557 57.6797 392.131 55.3009 400.367C53.1976 407.985 53.1976 416.031 55.3009 423.649C57.6756 431.882 61.9278 439.451 67.7231 445.761C74.552 453.275 82.5525 459.633 91.414 464.59C101.691 470.414 112.622 475.001 123.978 478.254C136.5 481.859 149.344 484.237 162.327 485.352C175.734 486.559 189.221 486.559 202.628 485.352C215.611 484.237 228.455 481.859 240.977 478.254C252.337 475.002 263.268 470.409 273.541 464.572C282.415 459.626 290.428 453.273 297.268 445.761C303.063 439.451 307.315 431.882 309.69 423.649C311.793 416.031 311.793 407.985 309.69 400.367Z",
    fill: "#37474F"
  })), _path120 || (_path120 = /*#__PURE__*/React.createElement("path", {
    d: "M53.7036 400.349H311.251V413.481L53.7036 412.754V400.349Z",
    fill: "#37474F"
  })), _path121 || (_path121 = /*#__PURE__*/React.createElement("path", {
    d: "M162.398 326.952L182.522 400.349L124.067 334.121C136.579 330.486 149.418 328.085 162.398 326.952Z",
    fill: "#455A64"
  })), _path122 || (_path122 = /*#__PURE__*/React.createElement("path", {
    d: "M202.628 326.952L182.504 400.349L162.398 326.952C175.78 325.731 189.246 325.731 202.628 326.952Z",
    fill: "#455A64"
  })), _path123 || (_path123 = /*#__PURE__*/React.createElement("path", {
    d: "M240.941 334.121L182.504 400.349L202.628 326.952C215.603 328.083 228.435 330.485 240.941 334.121Z",
    fill: "#455A64"
  })), _path124 || (_path124 = /*#__PURE__*/React.createElement("path", {
    d: "M297.268 366.614C303.06 372.94 307.311 380.52 309.69 388.761L182.54 400.385L297.268 366.614Z",
    fill: "#455A64"
  })), _path125 || (_path125 = /*#__PURE__*/React.createElement("path", {
    d: "M309.69 388.761C311.793 396.373 311.793 404.413 309.69 412.026L182.54 400.385L309.69 388.761Z",
    fill: "#455A64"
  })), _path126 || (_path126 = /*#__PURE__*/React.createElement("path", {
    d: "M309.69 412.026C307.312 420.262 303.06 427.836 297.268 434.155L182.54 400.438L309.69 412.026Z",
    fill: "#455A64"
  })), _path127 || (_path127 = /*#__PURE__*/React.createElement("path", {
    d: "M297.267 434.155C290.424 441.655 282.419 448.007 273.559 452.966L182.486 400.385L297.267 434.155Z",
    fill: "#455A64"
  })), _path128 || (_path128 = /*#__PURE__*/React.createElement("path", {
    d: "M182.504 400.402L240.977 466.648C228.455 470.253 215.611 472.631 202.628 473.747L182.469 400.349L182.504 400.402Z",
    fill: "#455A64"
  })), _path129 || (_path129 = /*#__PURE__*/React.createElement("path", {
    d: "M182.469 400.42L202.628 473.747C189.245 474.958 175.781 474.958 162.398 473.747L182.469 400.42Z",
    fill: "#455A64"
  })), _path130 || (_path130 = /*#__PURE__*/React.createElement("path", {
    d: "M182.451 400.402L162.398 473.747C149.415 472.631 136.571 470.253 124.049 466.648L182.451 400.402Z",
    fill: "#455A64"
  })), _path131 || (_path131 = /*#__PURE__*/React.createElement("path", {
    d: "M182.451 400.402L123.889 466.648C112.566 463.375 101.666 458.782 91.4141 452.966L182.451 400.402Z",
    fill: "#455A64"
  })), _path132 || (_path132 = /*#__PURE__*/React.createElement("path", {
    d: "M182.433 400.385L67.7054 434.102C61.913 427.783 57.6614 420.209 55.2832 411.973L182.433 400.385Z",
    fill: "#455A64"
  })), _path133 || (_path133 = /*#__PURE__*/React.createElement("path", {
    d: "M182.433 400.385L55.2831 412.026C53.1804 404.413 53.1804 396.373 55.2831 388.761L182.433 400.385Z",
    fill: "#455A64"
  })), _path134 || (_path134 = /*#__PURE__*/React.createElement("path", {
    d: "M182.433 400.367L55.2832 388.743C57.6619 380.502 61.9133 372.923 67.7054 366.596L182.433 400.367Z",
    fill: "#455A64"
  })), _path135 || (_path135 = /*#__PURE__*/React.createElement("path", {
    d: "M91.414 347.75L182.433 400.296L67.7231 366.578C74.5508 359.063 82.5515 352.705 91.414 347.75Z",
    fill: "#455A64"
  })), _path136 || (_path136 = /*#__PURE__*/React.createElement("path", {
    d: "M273.541 347.75L182.504 400.296L240.941 334.068C252.312 337.321 263.255 341.914 273.541 347.75Z",
    fill: "#455A64"
  })), _path137 || (_path137 = /*#__PURE__*/React.createElement("path", {
    d: "M273.541 347.75C282.416 352.717 290.428 359.087 297.267 366.614L182.557 400.331L273.541 347.75Z",
    fill: "#455A64"
  })), _path138 || (_path138 = /*#__PURE__*/React.createElement("path", {
    d: "M182.451 400.367L91.4137 452.966C82.5507 448.011 74.545 441.66 67.7051 434.155L182.433 400.438L182.451 400.367Z",
    fill: "#455A64"
  })), _path139 || (_path139 = /*#__PURE__*/React.createElement("path", {
    d: "M123.996 334.121L182.451 400.349L91.4141 347.75C101.698 341.935 112.635 337.36 123.996 334.121Z",
    fill: "#455A64"
  })), _path140 || (_path140 = /*#__PURE__*/React.createElement("path", {
    d: "M182.504 400.402L273.541 452.966C263.261 458.789 252.331 463.381 240.977 466.648L182.504 400.402Z",
    fill: "#455A64"
  })), _path141 || (_path141 = /*#__PURE__*/React.createElement("path", {
    d: "M216.719 354.848L231.394 338.202C231.394 318.682 207.544 318.203 197.003 317.262C186.462 316.322 168.378 310.27 168.378 332.488L173.418 350.873C187.971 349.938 202.58 351.279 216.719 354.848Z",
    fill: "url(#paint30_linear_2263_7536)"
  })), _path142 || (_path142 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.6,
    d: "M216.719 354.848L231.394 338.202C231.394 318.682 207.544 318.203 197.003 317.262C186.462 316.322 168.378 310.27 168.378 332.488L173.418 350.873C187.971 349.938 202.58 351.279 216.719 354.848Z",
    fill: "#1C262B"
  })), _path143 || (_path143 = /*#__PURE__*/React.createElement("path", {
    d: "M216.719 328.708L231.394 312.08C210.845 306.732 189.555 304.802 168.378 306.366L173.418 324.68C187.973 323.762 202.583 325.122 216.719 328.708Z",
    fill: "url(#paint31_linear_2263_7536)"
  })), _path144 || (_path144 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.8,
    d: "M216.719 328.708L231.394 312.08C210.845 306.732 189.555 304.802 168.378 306.366L173.418 324.68C187.973 323.762 202.583 325.122 216.719 328.708Z",
    fill: "#1C262B"
  })), _path145 || (_path145 = /*#__PURE__*/React.createElement("path", {
    d: "M173.418 324.751V350.909L168.378 332.524V306.366L173.418 324.751Z",
    fill: "url(#paint32_linear_2263_7536)"
  })), _path146 || (_path146 = /*#__PURE__*/React.createElement("path", {
    d: "M231.394 312.08L216.718 328.708V354.884L231.394 338.238V312.08Z",
    fill: "url(#paint33_linear_2263_7536)"
  })), _g3 || (_g3 = /*#__PURE__*/React.createElement("g", {
    opacity: 0.6
  }, /*#__PURE__*/React.createElement("path", {
    d: "M173.418 324.751V350.909L168.378 332.524V306.366L173.418 324.751Z",
    fill: "#1C262B"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M231.394 312.08L216.719 328.708V354.884L231.394 338.238V312.08Z",
    fill: "#1C262B"
  }))), _path147 || (_path147 = /*#__PURE__*/React.createElement("path", {
    d: "M223.888 330.82V356.978C230.011 358.955 235.92 361.541 241.527 364.697C246.42 367.475 250.915 370.902 254.89 374.884L283.674 366.419C277.951 360.577 271.433 355.571 264.313 351.548C256.452 347.04 248.04 328.762 223.888 330.82Z",
    fill: "url(#paint34_linear_2263_7536)"
  })), _path148 || (_path148 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.6,
    d: "M223.888 330.82V356.978C230.011 358.955 235.92 361.541 241.527 364.697C246.42 367.475 250.915 370.902 254.89 374.884L283.674 366.419C277.951 360.577 271.433 355.571 264.313 351.548C256.452 347.04 248.04 328.762 223.888 330.82Z",
    fill: "black"
  })), _path149 || (_path149 = /*#__PURE__*/React.createElement("path", {
    d: "M238.564 314.21L223.888 330.82C230.017 332.782 235.928 335.369 241.527 338.54C246.42 341.318 250.915 344.744 254.89 348.726L283.674 340.261C277.96 334.409 271.441 329.401 264.313 325.39C256.154 320.753 247.522 317.005 238.564 314.21Z",
    fill: "url(#paint35_linear_2263_7536)"
  })), _path150 || (_path150 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.3,
    d: "M238.564 314.21L223.888 330.82C230.017 332.782 235.928 335.369 241.527 338.54C246.42 341.318 250.915 344.744 254.89 348.726L283.674 340.261C277.96 334.409 271.441 329.401 264.313 325.39C256.154 320.753 247.522 317.005 238.564 314.21Z",
    fill: "black"
  })), _path151 || (_path151 = /*#__PURE__*/React.createElement("path", {
    d: "M254.89 348.726L283.674 340.243V366.419L254.89 374.884V348.726Z",
    fill: "url(#paint36_linear_2263_7536)"
  })), _path152 || (_path152 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.6,
    d: "M254.89 348.726L283.674 340.243V366.419L254.89 374.884V348.726Z",
    fill: "black"
  })), _path153 || (_path153 = /*#__PURE__*/React.createElement("path", {
    d: "M298.119 371.938H288.394C288.04 371.476 287.738 371.015 287.383 370.553L258.563 352.807V378.983C264.704 386.88 267.028 395.504 265.431 403.969L297.267 406.933C297.806 404.293 298.074 401.606 298.066 398.912L298.119 371.938Z",
    fill: "url(#paint37_linear_2263_7536)"
  })), _path154 || (_path154 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.6,
    d: "M298.119 371.938H288.394C288.04 371.476 287.738 371.015 287.383 370.553L258.563 352.807V378.983C264.704 386.88 267.028 395.504 265.431 403.969L297.267 406.933C297.806 404.293 298.074 401.606 298.066 398.912L298.119 371.938Z",
    fill: "black"
  })), _path155 || (_path155 = /*#__PURE__*/React.createElement("path", {
    d: "M265.413 377.918L297.267 380.775C299.858 368.477 296.575 355.824 287.365 344.396L258.546 352.861C264.686 360.758 267.099 369.4 265.413 377.918Z",
    fill: "url(#paint38_linear_2263_7536)"
  })), _path156 || (_path156 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.3,
    d: "M265.413 377.918L297.267 380.775C299.858 368.477 296.575 355.824 287.365 344.396L258.546 352.861C264.686 360.758 267.099 369.4 265.413 377.918Z",
    fill: "black"
  })), _path157 || (_path157 = /*#__PURE__*/React.createElement("path", {
    d: "M297.267 380.775V406.951L265.413 404.023V377.865L297.267 380.775Z",
    fill: "url(#paint39_linear_2263_7536)"
  })), _path158 || (_path158 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.6,
    d: "M297.267 380.775V406.951L265.413 404.023V377.865L297.267 380.775Z",
    fill: "black"
  })), _path159 || (_path159 = /*#__PURE__*/React.createElement("path", {
    d: "M165.468 351.654V325.479C147.722 317.298 114.679 325.603 103.605 349.968L126.391 363.136C138.63 357.015 151.863 353.127 165.468 351.654Z",
    fill: "url(#paint40_linear_2263_7536)"
  })), _path160 || (_path160 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.3,
    d: "M165.468 351.654V325.479C147.722 317.298 114.679 325.603 103.605 349.968L126.391 363.136C138.63 357.015 151.863 353.127 165.468 351.654Z",
    fill: "black"
  })), _path161 || (_path161 = /*#__PURE__*/React.createElement("path", {
    d: "M165.468 325.479L160.41 307.041C138.956 309.454 119.311 315.363 103.623 323.811L126.409 336.96C138.643 330.841 151.869 326.953 165.468 325.479Z",
    fill: "url(#paint41_linear_2263_7536)"
  })), _path162 || (_path162 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.1,
    d: "M165.468 325.479L160.41 307.041C138.956 309.454 119.311 315.363 103.623 323.811L126.409 336.96C138.643 330.841 151.869 326.953 165.468 325.479Z",
    fill: "black"
  })), _path163 || (_path163 = /*#__PURE__*/React.createElement("path", {
    d: "M126.391 336.96V363.136L103.605 349.968V323.811L126.391 336.96Z",
    fill: "#263238"
  })), _path164 || (_path164 = /*#__PURE__*/React.createElement("path", {
    d: "M102.559 340.261L97.8736 353.233C82.5588 362.71 72.8872 374.12 68.9121 386.064L100.855 388.974C103.783 380.793 110.455 373.002 120.784 366.436V340.261H102.559Z",
    fill: "url(#paint42_linear_2263_7536)"
  })), _path165 || (_path165 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.3,
    d: "M102.559 340.261L97.8736 353.233C82.5588 362.71 72.8872 374.12 68.9121 386.064L100.855 388.974C103.783 380.793 110.455 373.002 120.784 366.436V340.261H102.559Z",
    fill: "black"
  })), _path166 || (_path166 = /*#__PURE__*/React.createElement("path", {
    d: "M120.713 340.261L97.8736 327.076C82.5588 336.534 72.8872 347.963 68.9121 359.888L100.855 362.816C103.712 354.635 110.385 346.827 120.713 340.261Z",
    fill: "url(#paint43_linear_2263_7536)"
  })), _path167 || (_path167 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.1,
    d: "M120.713 340.261L97.8736 327.076C82.5588 336.534 72.8872 347.963 68.9121 359.888L100.855 362.816C103.712 354.635 110.385 346.827 120.713 340.261Z",
    fill: "black"
  })), _path168 || (_path168 = /*#__PURE__*/React.createElement("path", {
    d: "M68.9121 359.888V386.064L100.784 388.974V362.816L68.9121 359.888Z",
    fill: "#263238"
  })), _path169 || (_path169 = /*#__PURE__*/React.createElement("path", {
    d: "M99.5238 393.57V367.395L90.0475 366.543L66.8357 372.594V398.734C66.9844 409.12 70.7497 419.13 77.4833 427.039L106.303 418.574C100.287 410.677 97.9444 402.035 99.5238 393.57Z",
    fill: "url(#paint44_linear_2263_7536)"
  })), _path170 || (_path170 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.3,
    d: "M99.5238 393.57V367.395L90.0475 366.543L66.8357 372.594V398.734C66.9844 409.12 70.7497 419.13 77.4833 427.039L106.303 418.574C100.287 410.677 97.9444 402.035 99.5238 393.57Z",
    fill: "black"
  })), _path171 || (_path171 = /*#__PURE__*/React.createElement("path", {
    d: "M77.5896 400.881L106.409 392.399V418.574L77.5896 427.039V400.881Z",
    fill: "#263238"
  })), _path172 || (_path172 = /*#__PURE__*/React.createElement("path", {
    d: "M99.5415 367.395L67.5987 364.484C65.0078 376.8 68.2908 389.435 77.501 400.881L106.32 392.399C100.287 384.502 97.9444 375.859 99.5415 367.395Z",
    fill: "url(#paint45_linear_2263_7536)"
  })), _path173 || (_path173 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.1,
    d: "M99.5415 367.395L67.5987 364.484C65.0078 376.8 68.2908 389.435 77.501 400.881L106.32 392.399C100.287 384.502 97.9444 375.859 99.5415 367.395Z",
    fill: "black"
  })), _path174 || (_path174 = /*#__PURE__*/React.createElement("path", {
    d: "M133.632 427.003C120.127 419.213 113.384 409.009 113.384 398.805V372.594H251.572V398.752C251.572 408.974 244.828 419.178 231.323 426.968C204.35 442.584 160.623 442.584 133.632 427.003Z",
    fill: "#37474F"
  })), _path175 || (_path175 = /*#__PURE__*/React.createElement("path", {
    d: "M182.486 412.523C220.641 412.523 251.571 394.662 251.571 372.63C251.571 350.597 220.641 332.737 182.486 332.737C144.332 332.737 113.401 350.597 113.401 372.63C113.401 394.662 144.332 412.523 182.486 412.523Z",
    fill: "#455A64"
  })), _path176 || (_path176 = /*#__PURE__*/React.createElement("path", {
    d: "M126.391 434.492V431.156L81.2634 405.016V431.156C86.9885 437.003 93.5129 442.01 100.642 446.027C108.801 450.664 117.433 454.412 126.391 457.207L141.05 440.597C136.009 438.956 131.107 436.915 126.391 434.492Z",
    fill: "url(#paint46_linear_2263_7536)"
  })), _path177 || (_path177 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.3,
    d: "M126.391 434.492V431.156L81.2634 405.016V431.156C86.9885 437.003 93.5129 442.01 100.642 446.027C108.801 450.664 117.433 454.412 126.391 457.207L141.05 440.597C136.009 438.956 131.107 436.915 126.391 434.492Z",
    fill: "black"
  })), _path178 || (_path178 = /*#__PURE__*/React.createElement("path", {
    d: "M123.357 406.72C118.458 403.949 113.957 400.528 109.976 396.551L81.1921 405.016C86.9218 410.858 93.4454 415.864 100.571 419.887C108.733 424.517 117.365 428.264 126.32 431.067L140.978 414.439C134.855 412.478 128.95 409.891 123.357 406.72Z",
    fill: "url(#paint47_linear_2263_7536)"
  })), _path179 || (_path179 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.1,
    d: "M123.357 406.72C118.458 403.949 113.957 400.528 109.976 396.551L81.1921 405.016C86.9218 410.858 93.4454 415.864 100.571 419.887C108.733 424.517 117.365 428.264 126.32 431.067L140.978 414.439C134.855 412.478 128.95 409.891 123.357 406.72Z",
    fill: "black"
  })), _path180 || (_path180 = /*#__PURE__*/React.createElement("path", {
    d: "M126.391 457.225V431.067L141.05 414.439V440.615L126.391 457.225Z",
    fill: "#263238"
  })), _path181 || (_path181 = /*#__PURE__*/React.createElement("path", {
    d: "M133.561 433.179V459.355C154.111 464.703 175.4 466.633 196.577 465.069V438.911L133.561 433.179Z",
    fill: "url(#paint48_linear_2263_7536)"
  })), _path182 || (_path182 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.1,
    d: "M133.561 433.179V459.355C154.111 464.703 175.4 466.633 196.577 465.069V438.911L133.561 433.179Z",
    fill: "black"
  })), _path183 || (_path183 = /*#__PURE__*/React.createElement("path", {
    d: "M148.201 416.551L133.525 433.179C154.075 438.525 175.364 440.461 196.541 438.911L191.537 420.508C176.974 421.453 162.352 420.118 148.201 416.551Z",
    fill: "url(#paint49_linear_2263_7536)"
  })), _path184 || (_path184 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.2,
    d: "M148.201 416.551L133.525 433.179C154.075 438.525 175.364 440.461 196.541 438.911L191.537 420.508C176.974 421.453 162.352 420.118 148.201 416.551Z",
    fill: "#1C262B"
  })), _path185 || (_path185 = /*#__PURE__*/React.createElement("path", {
    d: "M244.242 431.156L267.099 444.359C282.414 434.901 292.086 423.472 296.061 411.529V385.371L264.118 408.619C261.243 416.8 254.571 424.608 244.242 431.156Z",
    fill: "url(#paint50_linear_2263_7536)"
  })), _path186 || (_path186 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.1,
    d: "M244.242 431.156L267.099 444.359C282.414 434.901 292.086 423.472 296.061 411.529V385.371L264.118 408.619C261.243 416.8 254.571 424.608 244.242 431.156Z",
    fill: "black"
  })), _path187 || (_path187 = /*#__PURE__*/React.createElement("path", {
    d: "M244.242 404.999L267.099 418.202C282.414 408.725 292.086 397.314 296.061 385.371L264.118 382.461C261.243 390.642 254.571 398.432 244.242 404.999Z",
    fill: "url(#paint51_linear_2263_7536)"
  })), _path188 || (_path188 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.2,
    d: "M244.242 404.999L267.099 418.202C282.414 408.725 292.086 397.314 296.061 385.371L264.118 382.461C261.243 390.642 254.571 398.432 244.242 404.999Z",
    fill: "#1C262B"
  })), _path189 || (_path189 = /*#__PURE__*/React.createElement("path", {
    d: "M267.082 418.202V444.359L244.242 431.174V404.999L267.082 418.202Z",
    fill: "url(#paint52_linear_2263_7536)"
  })), _path190 || (_path190 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.3,
    d: "M267.082 418.202V444.359L244.242 431.174V404.999L267.082 418.202Z",
    fill: "black"
  })), _path191 || (_path191 = /*#__PURE__*/React.createElement("path", {
    d: "M204.545 438.254V445.353C202.859 445.619 201.191 445.85 199.487 446.045L204.545 464.465C225.219 462.158 244.988 456.568 261.332 447.731V421.484L204.545 438.254Z",
    fill: "url(#paint53_linear_2263_7536)"
  })), _path192 || (_path192 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.1,
    d: "M204.545 438.254V445.353C202.859 445.619 201.191 445.85 199.487 446.045L204.545 464.465C225.219 462.158 244.988 456.568 261.332 447.731V421.484L204.545 438.254Z",
    fill: "black"
  })), _path193 || (_path193 = /*#__PURE__*/React.createElement("path", {
    d: "M199.487 419.799L204.545 438.254C225.219 435.947 244.988 430.375 261.332 421.538L238.493 408.335C226.285 414.467 213.072 418.351 199.487 419.799Z",
    fill: "url(#paint54_linear_2263_7536)"
  })), _path194 || (_path194 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.2,
    d: "M199.487 419.799L204.545 438.254C225.219 435.947 244.988 430.375 261.332 421.538L238.493 408.335C226.285 414.467 213.072 418.351 199.487 419.799Z",
    fill: "#1C262B"
  })), _path195 || (_path195 = /*#__PURE__*/React.createElement("path", {
    d: "M204.545 438.201V464.359L199.487 445.974V419.799L204.545 438.201Z",
    fill: "url(#paint55_linear_2263_7536)"
  })), _path196 || (_path196 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.3,
    d: "M204.545 438.201V464.359L199.487 445.974V419.799L204.545 438.201Z",
    fill: "black"
  })), _path197 || (_path197 = /*#__PURE__*/React.createElement("path", {
    d: "M647.414 263.172C647.351 262.018 647.018 260.895 646.441 259.894C645.865 258.892 645.061 258.039 644.095 257.405L596.039 229.668C594.265 228.603 592.721 229.473 592.721 231.602V278.044C592.781 279.198 593.113 280.322 593.69 281.325C594.266 282.327 595.071 283.179 596.039 283.811L616.163 295.417L622.516 321.131C622.495 321.602 622.662 322.061 622.98 322.409C623.297 322.757 623.74 322.964 624.211 322.985C624.682 323.007 625.141 322.84 625.489 322.522C625.837 322.204 626.044 321.761 626.065 321.291L631.886 304.485L644.184 311.584C645.959 312.648 647.503 311.779 647.503 309.667L647.414 263.172Z",
    fill: "url(#paint56_linear_2263_7536)"
  })), _path198 || (_path198 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.5,
    d: "M647.414 263.172C647.351 262.018 647.018 260.895 646.441 259.894C645.865 258.892 645.061 258.039 644.095 257.405L596.039 229.668C594.265 228.603 592.721 229.473 592.721 231.602V278.044C592.781 279.198 593.113 280.322 593.69 281.325C594.266 282.327 595.071 283.179 596.039 283.811L616.163 295.417L622.516 321.131C622.495 321.602 622.662 322.061 622.98 322.409C623.297 322.757 623.74 322.964 624.211 322.985C624.682 323.007 625.141 322.84 625.489 322.522C625.837 322.204 626.044 321.761 626.065 321.291L631.886 304.485L644.184 311.584C645.959 312.648 647.503 311.779 647.503 309.667L647.414 263.172Z",
    fill: "#1C262B"
  })), _path199 || (_path199 = /*#__PURE__*/React.createElement("path", {
    d: "M610.928 250.821C611.909 251.379 612.815 252.059 613.626 252.844C614.35 253.549 614.998 254.328 615.56 255.169C616.047 255.913 616.446 256.711 616.749 257.547C616.999 258.258 617.16 258.997 617.228 259.747C617.228 260.51 617.317 261.309 617.317 262.143C617.317 262.977 617.317 263.74 617.228 264.45C617.185 265.022 617.021 265.578 616.749 266.083C616.483 266.549 616.062 266.907 615.56 267.094C614.927 267.268 614.259 267.268 613.626 267.094C612.671 266.873 611.759 266.495 610.928 265.976C609.943 265.424 609.03 264.751 608.213 263.971C607.486 263.286 606.842 262.518 606.296 261.682C605.369 260.31 604.79 258.732 604.611 257.085C604.611 256.322 604.611 255.524 604.611 254.69C604.611 253.856 604.611 253.093 604.611 252.401C604.665 251.823 604.834 251.262 605.107 250.75C605.364 250.277 605.788 249.916 606.296 249.739C606.917 249.543 607.577 249.513 608.213 249.65C609.18 249.877 610.099 250.274 610.928 250.821ZM627.893 261.628C628.075 261.495 628.29 261.415 628.514 261.398C628.837 261.419 629.149 261.523 629.42 261.699L631.957 263.172C632.248 263.338 632.502 263.561 632.702 263.829C632.869 264.056 632.961 264.328 632.969 264.61C632.975 264.669 632.975 264.728 632.969 264.787C632.938 264.853 632.896 264.913 632.844 264.965L611.94 280.404C611.758 280.539 611.544 280.624 611.319 280.652C610.993 280.631 610.68 280.52 610.414 280.333L607.876 278.878C607.581 278.71 607.326 278.48 607.13 278.203C606.96 277.984 606.86 277.718 606.847 277.44C606.833 277.376 606.833 277.309 606.847 277.245C606.871 277.176 606.914 277.114 606.971 277.067L627.893 261.628ZM613.164 261.628C613.189 261.369 613.189 261.107 613.164 260.848V258.558C613.188 258.281 613.188 258.002 613.164 257.724C613.107 257.101 612.919 256.496 612.614 255.95C612.205 255.285 611.622 254.745 610.928 254.388C610.112 253.909 609.544 253.785 609.154 253.998C608.986 254.132 608.85 254.302 608.754 254.496C608.659 254.689 608.608 254.9 608.603 255.116C608.603 255.275 608.603 255.524 608.603 255.897C608.603 256.269 608.603 256.624 608.603 257.014C608.603 257.405 608.603 257.795 608.603 258.168C608.603 258.541 608.603 258.825 608.603 259.02C608.67 259.641 608.857 260.244 609.154 260.794C609.589 261.469 610.203 262.01 610.928 262.356C611.744 262.835 612.312 262.959 612.614 262.746C612.775 262.618 612.905 262.456 612.997 262.273C613.089 262.089 613.14 261.887 613.146 261.682L613.164 261.628ZM629.242 276.198C630.228 276.756 631.14 277.436 631.957 278.221C632.677 278.926 633.319 279.705 633.874 280.546C634.375 281.282 634.775 282.081 635.063 282.924C635.309 283.636 635.476 284.374 635.56 285.124C635.56 285.887 635.56 286.686 635.56 287.52C635.56 288.354 635.56 289.117 635.56 289.827C635.505 290.399 635.336 290.954 635.063 291.459C634.941 291.698 634.774 291.911 634.57 292.085C634.366 292.258 634.129 292.39 633.874 292.471C633.248 292.654 632.583 292.654 631.957 292.471C630.997 292.25 630.08 291.872 629.242 291.353C628.262 290.801 627.356 290.127 626.545 289.348C625.817 288.659 625.168 287.891 624.61 287.058C624.119 286.317 623.72 285.518 623.421 284.68C623.173 283.969 623.012 283.23 622.942 282.48C622.942 281.699 622.942 280.901 622.942 280.067C622.942 279.232 622.942 278.469 622.942 277.777C622.983 277.199 623.146 276.637 623.421 276.127C623.682 275.657 624.105 275.297 624.61 275.115C625.246 274.959 625.909 274.959 626.545 275.115C627.504 275.332 628.417 275.717 629.242 276.251V276.198ZM631.496 287.058C631.51 286.798 631.51 286.538 631.496 286.278V284.042C631.496 283.687 631.496 283.403 631.496 283.225C631.422 282.605 631.235 282.004 630.946 281.451C630.505 280.78 629.892 280.241 629.171 279.889C628.355 279.41 627.787 279.286 627.485 279.499C627.317 279.633 627.181 279.803 627.086 279.997C626.991 280.19 626.939 280.401 626.935 280.617C626.917 280.877 626.917 281.138 626.935 281.397C626.935 281.752 626.935 282.125 626.935 282.516C626.935 282.906 626.935 283.296 626.935 283.687C626.918 283.964 626.918 284.243 626.935 284.521C626.99 285.145 627.178 285.75 627.485 286.295C627.889 286.964 628.473 287.505 629.171 287.857C629.987 288.336 630.555 288.46 630.946 288.247C631.112 288.108 631.247 287.934 631.342 287.738C631.437 287.543 631.489 287.329 631.496 287.112V287.058Z",
    fill: "#658696"
  })), _path200 || (_path200 = /*#__PURE__*/React.createElement("path", {
    d: "M439.519 85.1092C439.455 83.9555 439.121 82.8329 438.545 81.8314C437.969 80.8299 437.166 79.9772 436.201 79.3417L388.145 51.6225C386.37 50.5577 384.826 51.4095 384.826 53.539V99.9803C384.888 101.137 385.22 102.263 385.797 103.268C386.373 104.273 387.177 105.128 388.145 105.765L408.269 117.371L414.622 143.032C414.691 143.43 414.894 143.792 415.197 144.058C415.5 144.325 415.885 144.48 416.288 144.499C416.691 144.518 417.088 144.398 417.415 144.161C417.741 143.923 417.976 143.581 418.082 143.192L423.903 126.386L436.201 133.485C437.975 134.549 439.519 133.698 439.519 131.568V85.1092Z",
    fill: "url(#paint57_linear_2263_7536)"
  })), _path201 || (_path201 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.5,
    d: "M439.519 85.1092C439.455 83.9555 439.121 82.8329 438.545 81.8314C437.969 80.8299 437.166 79.9772 436.201 79.3417L388.145 51.6225C386.37 50.5577 384.826 51.4095 384.826 53.539V99.9803C384.888 101.137 385.22 102.263 385.797 103.268C386.373 104.273 387.177 105.128 388.145 105.765L408.269 117.371L414.622 143.032C414.691 143.43 414.894 143.792 415.197 144.058C415.5 144.325 415.885 144.48 416.288 144.499C416.691 144.518 417.088 144.398 417.415 144.161C417.741 143.923 417.976 143.581 418.082 143.192L423.903 126.386L436.201 133.485C437.975 134.549 439.519 133.698 439.519 131.568V85.1092Z",
    fill: "#1C262B"
  })), _path202 || (_path202 = /*#__PURE__*/React.createElement("path", {
    d: "M403.034 72.8289C404.015 73.3868 404.921 74.0666 405.731 74.8519C406.451 75.5609 407.099 76.3396 407.666 77.1767C408.16 77.9165 408.559 78.7154 408.855 79.5546C409.105 80.2655 409.265 81.0047 409.334 81.7551C409.334 82.5182 409.422 83.3168 409.422 84.1509C409.422 84.9849 409.422 85.748 409.334 86.4578C409.293 87.0357 409.13 87.5983 408.855 88.1082C408.597 88.577 408.173 88.9318 407.666 89.102C407.041 89.3058 406.372 89.3364 405.731 89.1907C404.774 88.9696 403.861 88.5854 403.034 88.055C402.044 87.509 401.132 86.8347 400.319 86.0497C399.592 85.3651 398.948 84.5967 398.402 83.7604C397.901 83.0246 397.501 82.2248 397.213 81.3825C396.966 80.6697 396.8 79.9316 396.716 79.182C396.716 78.4011 396.716 77.6026 396.716 76.7862C396.716 75.9699 396.716 75.1714 396.716 74.4793C396.771 73.9017 396.94 73.3407 397.213 72.8289C397.47 72.3556 397.894 71.995 398.402 71.8174C399.031 71.6603 399.69 71.6603 400.319 71.8174C401.275 71.9953 402.194 72.3375 403.034 72.8289ZM419.999 83.6362C420.185 83.5108 420.398 83.4317 420.62 83.4055C420.945 83.4268 421.259 83.5374 421.525 83.7249L424.063 85.1801C424.35 85.3506 424.603 85.5733 424.808 85.8367C424.972 86.0649 425.065 86.3367 425.074 86.6175C425.081 86.6824 425.081 86.7479 425.074 86.8128C425.039 86.8759 424.997 86.9353 424.95 86.9902L404.045 102.429C403.86 102.555 403.647 102.634 403.424 102.66C403.099 102.639 402.786 102.528 402.519 102.34L399.982 100.885C399.687 100.725 399.433 100.5 399.236 100.229C399.072 100.001 398.98 99.7288 398.97 99.4479C398.953 99.3899 398.953 99.3284 398.97 99.2704C398.994 99.1959 399.037 99.1287 399.094 99.0752L419.999 83.6362ZM405.27 83.6362C405.296 83.3766 405.296 83.115 405.27 82.8554V80.5662C405.294 80.2946 405.294 80.0214 405.27 79.7498C405.218 79.1253 405.03 78.5198 404.72 77.9752C404.317 77.3011 403.733 76.7538 403.034 76.3958C402.218 75.9344 401.65 75.7925 401.259 76.0232C401.095 76.1611 400.961 76.3317 400.866 76.5242C400.772 76.7167 400.718 76.9268 400.709 77.1412C400.709 77.2831 400.709 77.5493 400.709 77.9043C400.709 78.2592 400.709 78.6318 400.709 79.04C400.709 79.4482 400.709 79.8208 400.709 80.1935C400.709 80.5661 400.709 80.8501 400.709 81.0275C400.778 81.6486 400.965 82.2508 401.259 82.8021C401.695 83.4772 402.309 84.0179 403.034 84.3638C403.85 84.8429 404.418 84.9672 404.72 84.7542C404.884 84.6276 405.018 84.4667 405.113 84.2827C405.208 84.0988 405.261 83.8963 405.27 83.6894V83.6362ZM421.348 98.2057C422.339 98.7637 423.251 99.4498 424.063 100.246C424.786 100.941 425.429 101.715 425.979 102.553C426.477 103.291 426.877 104.091 427.168 104.931C427.413 105.645 427.58 106.383 427.665 107.132C427.665 107.913 427.665 108.711 427.665 109.545C427.665 110.379 427.665 111.142 427.665 111.835C427.611 112.412 427.442 112.973 427.168 113.485C426.912 113.958 426.488 114.319 425.979 114.496C425.353 114.672 424.69 114.672 424.063 114.496C423.103 114.275 422.185 113.898 421.348 113.378C420.374 112.816 419.469 112.143 418.65 111.373C417.926 110.674 417.278 109.901 416.716 109.066C416.229 108.322 415.83 107.524 415.527 106.688C415.277 105.977 415.116 105.238 415.048 104.488C415.048 103.725 414.959 102.926 414.959 102.092C414.959 101.258 414.959 100.495 415.048 99.7851C415.091 99.2076 415.254 98.6454 415.527 98.1347C415.793 97.6733 416.215 97.3212 416.716 97.1409C417.341 96.9396 418.007 96.9029 418.65 97.0344C419.613 97.284 420.526 97.6982 421.348 98.2589V98.2057ZM423.601 109.066C423.616 108.806 423.616 108.545 423.601 108.285V106.049C423.601 105.694 423.601 105.411 423.601 105.233C423.54 104.61 423.353 104.007 423.051 103.458C422.617 102.778 422.003 102.231 421.277 101.879C420.46 101.418 419.893 101.276 419.591 101.506C419.42 101.639 419.282 101.808 419.187 102.002C419.091 102.196 419.041 102.408 419.041 102.624C419.021 102.878 419.021 103.134 419.041 103.388C419.041 103.742 419.041 104.115 419.041 104.523C419.041 104.931 419.041 105.304 419.041 105.677C419.023 105.954 419.023 106.233 419.041 106.511C419.093 107.135 419.281 107.741 419.591 108.285C419.994 108.959 420.578 109.507 421.277 109.865C422.093 110.326 422.685 110.45 423.051 110.237C423.219 110.103 423.355 109.933 423.45 109.739C423.545 109.546 423.597 109.335 423.601 109.119V109.066Z",
    fill: "#658696"
  })), _path203 || (_path203 = /*#__PURE__*/React.createElement("path", {
    d: "M109.586 261.735C109.649 260.581 109.982 259.458 110.558 258.456C111.135 257.454 111.938 256.602 112.904 255.968L160.961 228.231C162.735 227.166 164.279 228.035 164.279 230.165V276.606C164.219 277.761 163.887 278.885 163.31 279.887C162.734 280.889 161.929 281.741 160.961 282.374L140.837 293.979L134.484 319.658C134.505 320.129 134.338 320.588 134.02 320.936C133.702 321.284 133.259 321.491 132.789 321.512C132.318 321.534 131.858 321.367 131.511 321.049C131.163 320.731 130.955 320.288 130.934 319.818L125.131 303.012L112.833 310.111C111.059 311.175 109.515 310.306 109.515 308.194L109.586 261.735Z",
    fill: "url(#paint58_linear_2263_7536)"
  })), _g4 || (_g4 = /*#__PURE__*/React.createElement("g", {
    opacity: 0.5
  }, /*#__PURE__*/React.createElement("path", {
    d: "M109.586 261.735C109.649 260.581 109.982 259.458 110.558 258.456C111.135 257.454 111.938 256.602 112.904 255.968L160.961 228.231C162.735 227.166 164.279 228.035 164.279 230.165V276.606C164.219 277.761 163.887 278.885 163.31 279.887C162.734 280.889 161.929 281.741 160.961 282.374L140.837 293.979L134.484 319.658C134.505 320.129 134.338 320.588 134.02 320.936C133.702 321.284 133.259 321.491 132.789 321.512C132.318 321.534 131.858 321.367 131.511 321.049C131.163 320.731 130.955 320.288 130.934 319.818L125.131 303.012L112.833 310.111C111.059 311.175 109.515 310.306 109.515 308.194L109.586 261.735Z",
    fill: "#1C262B"
  }))), _path204 || (_path204 = /*#__PURE__*/React.createElement("path", {
    d: "M126.374 258.274C127.334 257.677 128.391 257.251 129.497 257.014C130.24 256.864 131.008 256.901 131.733 257.121C132.316 257.331 132.802 257.748 133.099 258.292C133.417 258.878 133.604 259.526 133.65 260.191C133.721 261.007 133.756 261.895 133.756 262.853C133.756 263.811 133.721 264.734 133.65 265.621C133.572 266.492 133.387 267.351 133.099 268.177C132.759 269.141 132.3 270.059 131.733 270.91C131.091 271.879 130.341 272.772 129.497 273.572C128.554 274.47 127.505 275.251 126.374 275.896C125.402 276.491 124.341 276.928 123.233 277.192C122.498 277.355 121.734 277.325 121.014 277.103C120.431 276.893 119.945 276.476 119.648 275.932C119.325 275.347 119.131 274.699 119.08 274.033C119.08 273.217 119.08 272.258 119.08 271.371C119.08 270.484 119.08 269.49 119.08 268.603C119.165 267.731 119.356 266.873 119.648 266.047C119.981 265.08 120.44 264.161 121.014 263.314C121.66 262.347 122.403 261.449 123.233 260.635C124.18 259.723 125.235 258.93 126.374 258.274ZM145.894 248.141C146.096 247.753 146.333 247.385 146.604 247.041C146.903 246.7 147.257 246.412 147.651 246.189L150.597 244.415C150.842 244.234 151.148 244.158 151.449 244.202C151.662 244.202 151.768 244.433 151.768 244.717C151.781 244.811 151.781 244.906 151.768 245L151.626 245.373L127.456 291.122C127.255 291.505 127.017 291.868 126.746 292.205C126.452 292.55 126.097 292.838 125.699 293.057L122.771 294.831C122.519 295.011 122.208 295.087 121.902 295.044C121.689 295.044 121.582 294.813 121.582 294.53C121.57 294.435 121.57 294.34 121.582 294.246L121.724 293.873L145.894 248.141ZM128.965 267.893C128.989 267.574 128.989 267.253 128.965 266.935V264.29C128.99 263.989 128.99 263.686 128.965 263.385C128.955 263.137 128.893 262.893 128.783 262.67C128.673 262.446 128.517 262.249 128.326 262.09C127.971 261.841 127.314 262.09 126.374 262.534C125.648 262.899 125.028 263.446 124.574 264.12C124.121 264.794 123.848 265.574 123.783 266.384C123.757 266.709 123.757 267.036 123.783 267.36C123.783 267.786 123.783 268.23 123.783 268.691C123.783 269.153 123.783 269.579 123.783 270.005C123.755 270.3 123.755 270.597 123.783 270.892C123.783 271.142 123.84 271.389 123.951 271.614C124.062 271.839 124.223 272.035 124.422 272.187C124.777 272.436 125.415 272.276 126.374 271.744C127.174 271.342 127.85 270.728 128.326 269.969C128.679 269.328 128.897 268.621 128.965 267.893ZM147.545 263.279C148.513 262.681 149.575 262.249 150.686 262.001C151.422 261.851 152.185 261.888 152.904 262.108C153.487 262.318 153.973 262.735 154.27 263.279C154.593 263.864 154.787 264.511 154.838 265.178C154.838 265.994 154.927 266.952 154.927 267.84C154.927 268.727 154.927 269.721 154.838 270.608C154.755 271.48 154.564 272.338 154.27 273.163C153.934 274.135 153.475 275.059 152.904 275.914C151.545 277.966 149.721 279.668 147.58 280.883C146.616 281.482 145.561 281.919 144.457 282.178C143.717 282.351 142.945 282.321 142.221 282.09C141.634 281.885 141.146 281.467 140.854 280.918C140.535 280.333 140.347 279.685 140.304 279.02C140.304 278.221 140.198 277.245 140.198 276.375C140.198 275.506 140.198 274.477 140.304 273.589C140.381 272.724 140.566 271.871 140.854 271.052C141.194 270.082 141.653 269.158 142.221 268.301C142.867 267.329 143.617 266.431 144.457 265.621C145.376 264.69 146.414 263.884 147.545 263.226V263.279ZM150.136 272.826C150.16 272.507 150.16 272.187 150.136 271.868V269.241C150.161 268.94 150.161 268.638 150.136 268.336C150.137 268.086 150.08 267.838 149.969 267.613C149.858 267.388 149.696 267.193 149.497 267.041C149.142 266.793 148.503 266.935 147.545 267.485C146.747 267.891 146.073 268.504 145.593 269.259C145.25 269.892 145.033 270.585 144.954 271.3C144.937 271.619 144.937 271.939 144.954 272.258C144.954 272.702 144.954 273.146 144.954 273.589C144.954 274.033 144.954 274.494 144.954 274.902C144.935 275.198 144.935 275.494 144.954 275.79C144.963 276.038 145.025 276.282 145.135 276.505C145.245 276.729 145.401 276.926 145.593 277.085C145.948 277.334 146.604 277.192 147.545 276.642C148.346 276.24 149.021 275.626 149.497 274.867C149.863 274.225 150.081 273.51 150.136 272.773V272.826Z",
    fill: "#658696"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_2263_7536",
    x1: 29.7324,
    y1: 273.351,
    x2: 99.1223,
    y2: 307.087,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#72D65A"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#035E93"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint1_linear_2263_7536",
    x1: 16.9232,
    y1: 312.158,
    x2: 84.1213,
    y2: 361.522,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#72D65A"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#035E93"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint2_linear_2263_7536",
    x1: 669.462,
    y1: 273.599,
    x2: 712.722,
    y2: 286.777,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#72D65A"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#035E93"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint3_linear_2263_7536",
    x1: 691.566,
    y1: 297.939,
    x2: 770.472,
    y2: 359.943,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#72D65A"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#035E93"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint4_linear_2263_7536",
    x1: 316.787,
    y1: 122.683,
    x2: 373.339,
    y2: 181.834,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#72D65A"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#035E93"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint5_linear_2263_7536",
    x1: 316.787,
    y1: 139.223,
    x2: 378.63,
    y2: 198.376,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#72D65A"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#035E93"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint6_linear_2263_7536",
    x1: 402.561,
    y1: 145.647,
    x2: 459.574,
    y2: 212.718,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#72D65A"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#035E93"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint7_linear_2263_7536",
    x1: 399.818,
    y1: 122.236,
    x2: 457.023,
    y2: 191.856,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#72D65A"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#035E93"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint8_linear_2263_7536",
    x1: 411.176,
    y1: 168.826,
    x2: 501.756,
    y2: 257.914,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#72D65A"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#035E93"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint9_linear_2263_7536",
    x1: 411.2,
    y1: 145.978,
    x2: 501.846,
    y2: 235.025,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#72D65A"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#035E93"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint10_linear_2263_7536",
    x1: 398.055,
    y1: 187.668,
    x2: 465.243,
    y2: 229.867,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#72D65A"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#035E93"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint11_linear_2263_7536",
    x1: 303.678,
    y1: 160.081,
    x2: 407.488,
    y2: 295.557,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#72D65A"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#035E93"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint12_linear_2263_7536",
    x1: 303.678,
    y1: 137.314,
    x2: 407.48,
    y2: 272.788,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#72D65A"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#035E93"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint13_linear_2263_7536",
    x1: 455.726,
    y1: 366.693,
    x2: 458.048,
    y2: 366.769,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#72D65A"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#035E93"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint14_linear_2263_7536",
    x1: 484.449,
    y1: 358.471,
    x2: 492.515,
    y2: 396.568,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#72D65A"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#035E93"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint15_linear_2263_7536",
    x1: 485.503,
    y1: 337.448,
    x2: 501.914,
    y2: 390.156,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#72D65A"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#035E93"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint16_linear_2263_7536",
    x1: 493.785,
    y1: 318.51,
    x2: 531.259,
    y2: 388.324,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#72D65A"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#035E93"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint17_linear_2263_7536",
    x1: 509.577,
    y1: 304.696,
    x2: 565.52,
    y2: 370.345,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#72D65A"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#035E93"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint18_linear_2263_7536",
    x1: 531.284,
    y1: 297.467,
    x2: 589.674,
    y2: 337.165,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#72D65A"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#035E93"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint19_linear_2263_7536",
    x1: 561.414,
    y1: 296.53,
    x2: 609.944,
    y2: 319.032,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#72D65A"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#035E93"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint20_linear_2263_7536",
    x1: 583.457,
    y1: 297.467,
    x2: 641.847,
    y2: 337.165,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#72D65A"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#035E93"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint21_linear_2263_7536",
    x1: 638.327,
    y1: 360.305,
    x2: 712.129,
    y2: 406.487,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#72D65A"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#035E93"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint22_linear_2263_7536",
    x1: 598.993,
    y1: 337.483,
    x2: 615.402,
    y2: 390.193,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#72D65A"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#035E93"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint23_linear_2263_7536",
    x1: 599.352,
    y1: 358.368,
    x2: 607.496,
    y2: 396.645,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#72D65A"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#035E93"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint24_linear_2263_7536",
    x1: 598.988,
    y1: 367.54,
    x2: 615.435,
    y2: 420.3,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#72D65A"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#035E93"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint25_linear_2263_7536",
    x1: 596.202,
    y1: 365.429,
    x2: 633.694,
    y2: 435.262,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#72D65A"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#035E93"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint26_linear_2263_7536",
    x1: 590.818,
    y1: 304.732,
    x2: 646.761,
    y2: 370.381,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#72D65A"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#035E93"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint27_linear_2263_7536",
    x1: 596.184,
    y1: 318.501,
    x2: 633.742,
    y2: 388.378,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#72D65A"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#035E93"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint28_linear_2263_7536",
    x1: 590.845,
    y1: 363.826,
    x2: 646.792,
    y2: 429.451,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#72D65A"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#035E93"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint29_linear_2263_7536",
    x1: 485.512,
    y1: 366.668,
    x2: 509.108,
    y2: 428.526,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#72D65A"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#035E93"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint30_linear_2263_7536",
    x1: 184.336,
    y1: 310.668,
    x2: 219.949,
    y2: 359.727,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#72D65A"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#035E93"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint31_linear_2263_7536",
    x1: 184.336,
    y1: 302.83,
    x2: 200.137,
    y2: 339.99,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#72D65A"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#035E93"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint32_linear_2263_7536",
    x1: 169.655,
    y1: 300.503,
    x2: 177.832,
    y2: 301.292,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#72D65A"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#035E93"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint33_linear_2263_7536",
    x1: 220.435,
    y1: 306.446,
    x2: 242.572,
    y2: 312.924,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#72D65A"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#035E93"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint34_linear_2263_7536",
    x1: 239.028,
    y1: 324.837,
    x2: 281.026,
    y2: 373.294,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#72D65A"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#035E93"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint35_linear_2263_7536",
    x1: 239.028,
    y1: 309.666,
    x2: 269.764,
    y2: 355.103,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#72D65A"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#035E93"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint36_linear_2263_7536",
    x1: 262.179,
    y1: 335.683,
    x2: 293.542,
    y2: 357.925,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#72D65A"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#035E93"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint37_linear_2263_7536",
    x1: 268.58,
    y1: 345.682,
    x2: 315.215,
    y2: 374.769,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#72D65A"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#035E93"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint38_linear_2263_7536",
    x1: 268.568,
    y1: 339.607,
    x2: 303.375,
    y2: 371.925,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#72D65A"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#035E93"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint39_linear_2263_7536",
    x1: 273.48,
    y1: 374.036,
    x2: 301.321,
    y2: 400.059,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#72D65A"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#035E93"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint40_linear_2263_7536",
    x1: 119.271,
    y1: 317.069,
    x2: 157.042,
    y2: 366.056,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#72D65A"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#035E93"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint41_linear_2263_7536",
    x1: 119.285,
    y1: 303.102,
    x2: 143.914,
    y2: 346.55,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#72D65A"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#035E93"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint42_linear_2263_7536",
    x1: 82.0479,
    y1: 333.849,
    x2: 128.57,
    y2: 376.127,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#72D65A"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#035E93"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint43_linear_2263_7536",
    x1: 82.0299,
    y1: 322.371,
    x2: 115.558,
    y2: 363.844,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#72D65A"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#035E93"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint44_linear_2263_7536",
    x1: 76.8302,
    y1: 358.579,
    x2: 126.167,
    y2: 386.049,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#72D65A"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#035E93"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint45_linear_2263_7536",
    x1: 76.7649,
    y1: 359.693,
    x2: 111.587,
    y2: 392.009,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#72D65A"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#035E93"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint46_linear_2263_7536",
    x1: 96.4035,
    y1: 398.146,
    x2: 146.462,
    y2: 447.086,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#72D65A"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#035E93"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint47_linear_2263_7536",
    x1: 96.3322,
    y1: 392.008,
    x2: 127.068,
    y2: 437.445,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#72D65A"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#035E93"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint48_linear_2263_7536",
    x1: 149.519,
    y1: 428.912,
    x2: 177.018,
    y2: 474.536,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#72D65A"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#035E93"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint49_linear_2263_7536",
    x1: 149.483,
    y1: 413.539,
    x2: 165.295,
    y2: 450.711,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#72D65A"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#035E93"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint50_linear_2263_7536",
    x1: 257.365,
    y1: 377.606,
    x2: 311.688,
    y2: 418.334,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#72D65A"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#035E93"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint51_linear_2263_7536",
    x1: 257.365,
    y1: 377.756,
    x2: 290.891,
    y2: 419.24,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#72D65A"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#035E93"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint52_linear_2263_7536",
    x1: 250.026,
    y1: 399.817,
    x2: 280.061,
    y2: 414.691,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#72D65A"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#035E93"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint53_linear_2263_7536",
    x1: 215.148,
    y1: 415.826,
    x2: 255.529,
    y2: 465.415,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#72D65A"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#035E93"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint54_linear_2263_7536",
    x1: 215.148,
    y1: 404.396,
    x2: 239.778,
    y2: 447.844,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#72D65A"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#035E93"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint55_linear_2263_7536",
    x1: 200.768,
    y1: 413.933,
    x2: 208.973,
    y2: 414.727,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#72D65A"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#035E93"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint56_linear_2263_7536",
    x1: 606.593,
    y1: 216.869,
    x2: 678.443,
    y2: 252.692,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#72D65A"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#035E93"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint57_linear_2263_7536",
    x1: 398.676,
    y1: 38.8771,
    x2: 470.323,
    y2: 74.7076,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#72D65A"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#035E93"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint58_linear_2263_7536",
    x1: 123.383,
    y1: 215.436,
    x2: 195.208,
    y2: 251.248,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#72D65A"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#035E93"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgStrategicPartnershipSection1);
export default __webpack_public_path__ + "static/media/StrategicPartnershipSection1.b7347037d87d1f99ad8e3dc4e3a6b673.svg";
export { ForwardRef as ReactComponent };